(($) => {

    'use strict'

    // Trigger resize for salient
	// ----------------------------------------------------------------------------------------------------
    $(document).ready(() => {
        window.dispatchEvent(new Event('resize'))
    })

    window.onload =  () => {

		window.dispatchEvent(new Event('resize'))

		$('input[name="recipient"]').val($('#form-data').data('recipient'))
		$('input[name="excursion"]').val($('#form-data').data('excursion'))
		
	}
    
})(jQuery)